// extracted by mini-css-extract-plugin
module.exports = {"container":"File__container___1f-Qn","input":"File__input___3n_jX","dragOver":"File__dragOver___2TL6P"};